import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DonationAccountsPage } from '@/features/marketPromotion/pages/DonationAccountsPage';
import { donationBatchSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/accounts-adjust')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.ACCOUNTS_ADJUST_VIEW),
  validateSearch: donationBatchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Accounts Adjust">
      <Suspense fallback={<PageLoader />}>
        <DonationAccountsPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
